import { createSlice } from '@reduxjs/toolkit';
import { ConfigureReportsState } from '../pages/Reports/interface';

const initialState: ConfigureReportsState = {
  isDrawerOpen: false,
  configureReportsData: [],
  configureReportsLoading: false,
  columnConfigurationData: null,
  columnConfigurationLoading: false,
  isModalOpen: false
};

const configureReportsSlice = createSlice({
  name: 'configureReport',
  initialState,
  reducers: {
    setIsDrawerOpen(state, action) {
      state.isDrawerOpen = action.payload;
    },

    setConfigureReportsData(state, action) {
      state.configureReportsData = action.payload;
    },

    setConfigureReportsLoading(state, action) {
      state.configureReportsLoading = action.payload;
    },

    setColumnConfigurationData(state, action) {
      state.columnConfigurationData = action.payload;
    },

    setColumnConfigurationLoading(state, action) {
      state.columnConfigurationLoading = action.payload;
    },

    clearColumnConfigurationData(state) {
      state.columnConfigurationData = null;
    },
    setIsModalOpen(state, action) {
      state.isModalOpen = action.payload;
    }
  }
});

export const {
  setIsDrawerOpen,
  setConfigureReportsData,
  setConfigureReportsLoading,
  setColumnConfigurationData,
  setColumnConfigurationLoading,
  clearColumnConfigurationData,
  setIsModalOpen
} = configureReportsSlice.actions;

export default configureReportsSlice.reducer;
